<template>
  <div v-if="cartStore.cartError" class="add-to-cart-error">
    There was an issue with your cart. Please refresh the
    <CustomButton
      :aria-attrs="{
        ariaLabel: 'Delete cart',
      }"
      style-name="tertiary"
      :is-small="true"
      :extra-classes="['cart-error-btn']"
      @click-button="() => handleRefresh('cart')"
    >
      cart
    </CustomButton>
    and try again.
    <ModalWindow v-if="state.showCartDeleteWarning" class="modal-delete-warning" @closed="closeModal">
      <ModalBodyError :cart-error="cartStore.cartError" class="modal-body" @emit-close="closeModal" />
    </ModalWindow>
  </div>
  <div v-else-if="errorCustom" class="add-to-cart-error">
    {{ errorCustom }}
  </div>
</template>

<script setup lang="ts">
import { useCartStore } from '~/store/cart';

const cartStore = useCartStore();

defineProps({
  errorCustom: {
    type: String,
    default: undefined,
  },
});

const state = reactive({
  showCartDeleteWarning: false,
});

function closeModal() {
  state.showCartDeleteWarning = false;
}
function handleRefresh(refreshMode = '') {
  switch (refreshMode) {
    case 'cart':
      state.showCartDeleteWarning = true;
      break;
    case 'confirm-delete':
      cartStore.resetCart();
      state.showCartDeleteWarning = false;
      window.location.reload();
      break;
  }
}
</script>

<style lang="scss" scoped>
.add-to-cart-error {
  color: $color-danger-default;
  width: 100%;
  padding: 0.625rem 0;
}
.cart-error-btn {
  display: inline;
  text-transform: none;
  text-decoration: underline;
  font-size: inherit;
}
</style>
